import { reactive } from "vue";
export const context = reactive({})

/**
 * 
 * @param String name 
 * @param {component:String,params:Object} config 
 * @returns 
 */
export const defineColumnComponent = (name, config) => {
    if (!name || !config) {
        return
    }
    context[name] = config
}

export const getColumnComponent = (name) => {
    return context[name]
}